import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import HeaderGridTemplate from "./header-template/header-grid";
import { DfpAd } from "../dfp-ad";
import headerConfig from "./header-config.json";

export class HeaderBase extends React.Component {
  constructor(props) {
    super(props);
    this.toggleSidebar = this.toggleSidebar.bind(this);
    this.toggleSearchForm = this.toggleSearchForm.bind(this);
    this.hideSearchForm = this.hideSearchForm.bind(this);
    this.closeAll = this.closeAll.bind(this);
    this.windowScroll = this.windowScroll.bind(this);
  }

  toggleSidebar() {
    this.props.dispatch({type: "TOGGLE_SIDEBAR_MENU"});
  };

  hideSearchForm() {
    this.props.dispatch({type: "CLOSE_SEARCHFORM"});
  }

  toggleSearchForm() {
    this.props.dispatch({type: "TOGGLE_SEARCHFORM"});
  }

  closeAll() {
    this.props.dispatch({type: "CLOSE_ALL"});
  }
  windowScroll() {
    window.scrollTo(0, 0);
  }


  render() {
    const headerConfigData = this.props.publisherTheme.header_theme &&
        headerConfig[this.props.publisherTheme.header_theme] ?
        headerConfig[this.props.publisherTheme.header_theme] :
        headerConfig["header_1"];
    return <React.Fragment>
      <div className="app-ad app-ad--leaderboard">
        <DfpAd adtype="Horizontal-Ad" layoutName="Navigation"/>
      </div>
      <HeaderGridTemplate {...this.props}
        toggleSidebar={this.toggleSidebar}
        toggleSearchForm={this.toggleSearchForm}
        hideSearchForm={this.hideSearchForm}
        closeAll={this.closeAll}
        windowScroll={this.windowScroll}
        headerConfig={headerConfigData} />
    </React.Fragment>;
  }
}

HeaderBase.propTypes = {
  publisherTheme: PropTypes.shape({
    logo: PropTypes.string,
    monogram: PropTypes.string,
    header_theme: PropTypes.string
  }),
  menu: PropTypes.array,
  socialLinks: PropTypes.shape({
    "facebook-url": PropTypes.string,
    "twitter-url": PropTypes.string,
  })
};

const mapStateToProps = state => {
  return {
    title: get(state.qt.config['publisher-settings'], ['title'], 'Madrid'),
    menu: get(state, ["qt", "data", "navigationMenu"], []),
    publisherTheme: state.qt.config['theme-attributes'] || {},
    publisherName: state.qt.config['publisher-name'],
    socialLinks: state.qt.config['social-links'],
    header: state.header,
    currentPath: state.qt.currentPath,
  }
};

const Header = connect(mapStateToProps)(HeaderBase);

export default Header;
